module.exports = __webpack_public_path__ + "img/news-02_2x.97f4ccdd.png";